export enum FabricMeta {
  MODEL = "fabric",
  PK = "id",
}
